<template>
  <div v-if="$store.state.user.logged && ['login', 'register', 'forgot-password', 'password_reset'].indexOf($route.name) === -1">
    <nav class="main-header navbar navbar-expand navbar-white navbar-light">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
        </li>
      </ul>

      <ul class="navbar-nav mx-auto">
        <li class="nav-item">
          <LanguageSelector variant="outline-secondary" size="sm" />
        </li>
      </ul>

      <ul class="navbar-nav ml-auto">
        <li v-if="false" class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#">
              <i class="far fa-bell"></i>
              <span class="badge badge-warning navbar-badge">15</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <span class="dropdown-item dropdown-header">15 Notifications</span>

            <div class="dropdown-divider"></div>

            <a href="#" class="dropdown-item">
              <i class="fas fa-envelope mr-2"></i> 4 new messages
              <span class="float-right text-muted text-sm">3 mins</span>
            </a>

            <div class="dropdown-divider"></div>

            <a href="#" class="dropdown-item">
              <i class="fas fa-users mr-2"></i> 8 friend requests
              <span class="float-right text-muted text-sm">12 hours</span>
            </a>

            <div class="dropdown-divider"></div>

            <a href="#" class="dropdown-item">
              <i class="fas fa-file mr-2"></i> 3 new reports
              <span class="float-right text-muted text-sm">2 days</span>
            </a>

            <div class="dropdown-divider"></div>

            <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
          </div>
        </li>

        <li class="nav-item">
            <a class="nav-link" @click="$root.$emit('openHelpModal', $t('changelog'), $t('changelog_title'), true, true)" href="#" role="button" :title="$t('changelog_title')">
                <i class="far fa-question-circle text-info"></i>
            </a>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link rounded-circle p-2" data-toggle="dropdown" href="#" :style="'color: #fff;background-color: ' + $root.colorFromString(userShortName) + ';'">
              {{ userShortName }}
          </a>
          <div class="dropdown-menu dropdown-menu-right p-0">
            <b-link href="#" :to="{name: 'password_change'}" class="dropdown-item">
              {{ $t('navbar.password_change') }}
            </b-link>
            <a class="dropdown-item" href="#" @click="userLogout">
              {{ $t('navbar.signout') }}
            </a>
          </div>
        </li>

        <li class="nav-item">
            <a class="nav-link" data-widget="fullscreen" href="#" role="button">
                <i class="fas fa-expand-arrows-alt"></i>
            </a>
        </li>
      </ul>
    </nav>

    <aside class="main-sidebar sidebar-dark-primary elevation-4">
      <b-link to="/" class="brand-link">
        <img src="/img/logo.png" :alt="$root.appname" class="brand-image img-circle elevation-3" style="opacity: .8">
        <span class="brand-text font-weight-light ml-2">{{ $root.appname }}</span>
      </b-link>

      <template v-if="$store.state.user.menuLoading">
        <b-skeleton v-for="(count, cindex) in 10" type="input" animation="fade" class="mb-2" :key="`sk_${cindex}`"></b-skeleton>
      </template>

      <template v-if="!$store.state.user.menuLoading && $store.state.user.userMenu && $store.state.user.userMenu.length > 0">
        <div class="sidebar">
          <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
              <template v-for="(menu, mkey) in $store.state.user.userMenu">
                <li
                  v-if="menu.childs && ( (Array.isArray(menu.childs) && menu.childs.length > 0) || !Array.isArray(menu.childs) )"
                  class="nav-item"
                  :class="checkActiveMenu(menu)"
                >
                  <b-link href="#" :disabled="$store.state.common.loading.length > 0" :to="menuUrl(menu)" class="nav-link">
                    <span v-if="menu.icon" v-html="menu.icon"></span>
                    <p>
                      {{ menu.title }}
                      <i class="right fas fa-angle-left"></i>
                    </p>
                  </b-link>
                  <template v-for="(child, ckey) in menu.childs">
                    <ul class="nav nav-treeview border-bottom border-white">
                      <li class="nav-item">
                        <b-link href="#" :disabled="$store.state.common.loading.length > 0" :to="menuUrl(child)" :active="activeClass(child)" class="nav-link">
                          <span v-if="child.icon" v-html="child.icon"></span>
                          <p>
                            {{ child.title }}
                          </p>
                        </b-link>
                      </li>
                    </ul>
                  </template>
                </li>
                <li v-else class="nav-item">
                  <b-link href="#" :disabled="$store.state.common.loading.length > 0" :to="menuUrl(menu)" class="nav-link">
                    <span v-if="menu.icon" v-html="menu.icon"></span>
                    <p>
                      {{ menu.title }}
                    </p>
                  </b-link>
                </li>
              </template>
            </ul>
          </nav>
        </div>
      </template>

      <div class="col-12 position-absolute text-center sidebar-footer" style="bottom:0;">
        <a>Version: {{ $root.appversion }}</a>
      </div>
    </aside>
  </div>
</template>

<script>
import LanguageSelector from '../components/LanguageSelector.vue'

export default {
  name: 'NavBar',
  mixins: [],
  props: {},
  components: { LanguageSelector },
  data () {
    return {
      name: ''
    }
  },
  methods: {
    userLogout () {
      this.$store.dispatch('user/logout').then((response) => {
        this.$root.$emit('disconnectUser')
        this.$nextTick(() => {
          this.$router.push('/login')
        })
      })
    },
    getMenu () {
      if (this.$store.state.user.logged === true) {
        this.$store.commit('user/setMenuLoading', true)
        this.$store.dispatch('user/getUserMenu')
          .then(resolve => {
            this.$store.commit('user/setMenuLoading')
            this.$nextTick(() => {
              $('[data-widget="treeview"]').Treeview('init')
            })
          })
          .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) {
              this.$root.$emit('showAlert', 'danger', error.response.data.message, 7)
            } else {
              this.$root.$emit('showAlert', 'danger', error.message, 7)
            }
          })
      }
    },
    menuUrl(menu) {
      if (menu.url) {
        return menu.url
      }

      if (menu.route) {
        return menu.route
      }

      return null
    },
    checkActiveMenu (menu) {
      return menu.active.indexOf(window.location.pathname.split('/')[1] || '') !== -1 ? 'menu-is-opening menu-open' : ''
    },
    activeClass (menu) {
      if(this.$route.name) {
        return menu.active.indexOf(this.$route.name.split('.')[0]) !== -1
      }

      return false
    }
  },
  computed: {
    userShortName () {
      return (this.$store.state.user.user && this.$store.state.user.user.name) ? this.$store.state.user.user.name.match(/\b\w/g).join('') : 'JD'
    }
  },
  watch: {
    '$store.state.user.logged' (newVal, oldVal) {
      if (newVal === true) {
        this.getMenu()
      }
    },
    '$route' (to, from) {
      if (this.$root.isMobileBrowser && from.name) {
        jQuery('[data-widget="pushmenu"]').PushMenu('toggle')
      }
    }
  },
  created () {
  },
  mounted () {
    this.getMenu()
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
